var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgObservePassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_3_1",
    "data-name": "Componente 3 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.771,
    height: 20.379,
    viewBox: "0 0 23.771 20.379",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-eye",
    "data-name": "Icon ionic-md-eye",
    d: "M13.768,7.383A12.386,12.386,0,0,0,2.25,15.147a12.425,12.425,0,0,0,23.036,0A12.386,12.386,0,0,0,13.768,7.383Zm0,12.942A5.178,5.178,0,1,1,19,15.147,5.221,5.221,0,0,1,13.768,20.325Zm0-8.284a3.106,3.106,0,1,0,3.142,3.106A3.134,3.134,0,0,0,13.768,12.041Z",
    transform: "translate(-1.515 -4.958)",
    fill: "rgba(26,26,26,0.5)",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-eye-off",
    "data-name": "Icon ionic-ios-eye-off",
    transform: "translate(-2.252 -4.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3",
    "data-name": "Caminho 3",
    d: "M5.791,4.717A.754.754,0,0,0,4.724,5.784L23.59,24.66a.748.748,0,0,0,.727.191.735.735,0,0,0,.34-.2.753.753,0,0,0,0-1.061Z",
    transform: "translate(-0.553 0)",
    fill: "rgba(26,26,26,0.5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20",
    "data-name": "Grupo 20",
    transform: "translate(2.252 7.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4",
    "data-name": "Caminho 4",
    d: "M14.36,21.184A4.771,4.771,0,0,1,9.823,14.37L6.989,11.531a37.224,37.224,0,0,0-4.516,4.314.839.839,0,0,0-.005,1.13c3.444,3.8,6.48,7.079,11.659,7.079a10.218,10.218,0,0,0,4.367-1.019l-2.308-2.308A4.822,4.822,0,0,1,14.36,21.184Z",
    transform: "translate(-2.252 -8.772)",
    fill: "rgba(26,26,26,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5",
    "data-name": "Caminho 5",
    d: "M28.247,16.047a.832.832,0,0,0,.027-1.1c-2.775-3.37-6.623-7.074-11.7-7.074A9.934,9.934,0,0,0,12.22,8.883L14.539,11.2a4.676,4.676,0,0,1,1.82-.456A4.771,4.771,0,0,1,20.9,17.56L23.736,20.4A35.1,35.1,0,0,0,28.247,16.047Z",
    transform: "translate(-4.697 -7.875)",
    fill: "rgba(26,26,26,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6",
    "data-name": "Caminho 6",
    d: "M13.511,17.939a3.41,3.41,0,0,0,3.126,3.126,3.317,3.317,0,0,0,1.242-.138l-4.235-4.235A3.471,3.471,0,0,0,13.511,17.939Z",
    transform: "translate(-5.011 -10.038)",
    fill: "rgba(26,26,26,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7",
    "data-name": "Caminho 7",
    d: "M22.131,17.933c0-.069-.005-.138-.005-.207a2.353,2.353,0,0,1-.966.207c-.058,0-.111,0-.165-.005l.987.992A3.393,3.393,0,0,0,22.131,17.933Z",
    transform: "translate(-6.849 -10.291)",
    fill: "rgba(26,26,26,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8",
    "data-name": "Caminho 8",
    d: "M17.681,14.4a2.493,2.493,0,0,1,.165-.9c-.053,0-.106-.005-.165-.005a3.357,3.357,0,0,0-.982.149l.992.992C17.686,14.561,17.681,14.482,17.681,14.4Z",
    transform: "translate(-5.795 -9.255)",
    fill: "rgba(26,26,26,0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObservePassword);
export default __webpack_public_path__ + "static/media/observePassword.a8281824c0bfbe8b6c3feb3c8559e177.svg";
export { ForwardRef as ReactComponent };